

// -------- Development extension index ---------
//      ! THIS FILE WAS AUTO-GENERATED !
//
// You can overwrite it and have fun, to restore
// the default state: 'npm run compile'

import ChartLink from '../build/chart-link/chart-link-dev.js'
import GridResize from '../build/grid-resize/grid-resize-dev.js'
import LegendButtons from '../build/legend-buttons/legend-buttons-dev.js'
import SettingsWin from '../build/settings-win/settings-win-dev.js'



const Pack = {
    'chart-link': ChartLink,
    'grid-resize': GridResize,
    'legend-buttons': LegendButtons,
    'settings-win': SettingsWin
}

export default Pack

export {
    
}